import { Button, Modal, Select, Space } from "antd";
import { Fragment, useEffect, useState } from "react";
import { Form } from "antd";
import { toast } from "react-toastify";
import { getRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import {
  MinusCircleOutlined,
} from "@ant-design/icons";
import closeIcon from "../../assets/images/closecross.svg";
import OrganiationSizes from "../json/organizationSize.json";
import "./filter.scss";
import poweredByLogo from "../../assets/images/powered_by_datacity_light.png";

function FilterHub({
  mask,
  interest,
  setData,
  updateFilterData,
  title,
  style,
  icon,
  sector,
  subsector,
  sizeHub,
}) {
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [sectors, setSectors] = useState([]);
  const [subSectors, setSubSectors] = useState([]);
  const [sectorValue, setSectorValue] = useState(
    sector ? sector : ""
  );
  const [subSectorValue, setSubsectorValue] = useState(
    subsector ? subsector : ""
  );
  const [sizeValue, setSizeValue] = useState(
    sizeHub ? sizeHub : ""
  );
  const [interestName, setinterestName] = useState(interest ? interest : "");
  const [organizationValue, setOrganizationValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  let sectorId = sector
  let subSectorId = subsector
  let size = sizeHub

  const sectorChange = async (sectorId, i) => {
    setSectorValue(sectorId);
    try {
      setLoading(true);
      const response = await getRequest(userServiceApi.getSubSectors(sectorId, "SUB_SECTOR"));
      setSubSectors(response.data);
      setSubsectorValue(subSectorId);
      setLoading(false);
    } catch (error) {
      toast.error(error.error);
      setLoading(false);
    }
  };

  const subSectorChange = async (subSectorIds) => {
    setSubsectorValue(subSectorIds);
  };

  const SizeChange = async (size) => {
    setSizeValue(size);
  };

  const fetchSectorList = async () => {
    try {
      const partnerId = sessionStorage.getItem("partnerId")
      const response = await getRequest(userServiceApi.getAllSectors(partnerId, "SECTOR"));
      setSectors(response.data);
      if (sectorId) {
        setSectorValue(sectorId);
        sectorChange(sectorId);
      }
      if (size) {
        setSizeValue(size);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleOk = (value) => {
    if (!sectorValue) {

    }
    setOpen(false);
    // sessionStorage.setItem("Interest/AssetType", interest ? interest : "");
    // sessionStorage.setItem("sector", sectorValue ? sectorValue : "");
    // sessionStorage.setItem("subsector", subSectorValue ? subSectorValue : "");
    // sessionStorage.setItem("size", sizeValue ? sizeValue : "");
    setData(sectorValue, subSectorValue, sizeValue);
  };

  const handleCancel = () => {
    setSectorValue(null);
    setSubSectors([]);
    setSubsectorValue(null);
    setSizeValue(null);
    setOpen(false);
    // sessionStorage.removeItem("sector");
    // sessionStorage.removeItem("subsector");
    // sessionStorage.removeItem("size");
  };

  const organizationNameChange = async (e) => {
    setOrganizationValue(e.target.value);
  };

  const deleteSelectedValue = (variableName) => {
    if (variableName == "sector") {
      setSectorValue(null);
      setSubSectors([]);
      setSubsectorValue(null);
      //   sessionStorage.removeItem("sector");
      //   sessionStorage.removeItem("subsector");
    }
    if (variableName == "subsector") {
      setSubsectorValue(null);
      //   sessionStorage.removeItem("subsector");
    }
    if (variableName == "size") {
      setSizeValue(null);
      //   sessionStorage.removeItem("size");
    }
  };

  useEffect(() => {
    fetchSectorList();
  }, []);

  useEffect(() => {
    setSectorValue(
      //   sessionStorage.getItem("sector") ? sessionStorage.getItem("sector") : ""
      sector
    );
    setSubsectorValue(
      //   sessionStorage.getItem("subsector") ? sessionStorage.getItem("subsector") : ""
      subsector
    );
    setSizeValue(
      //   sessionStorage.getItem("size") ? sessionStorage.getItem("size") : ""
      sizeHub
    );
  }, [updateFilterData]);

  return (
    <Fragment>
      <Button
        id="submit-btn"
        type="primary"
        // htmlType="button"
        className="filter-btn"
        onClick={() => setOpen(true)}
        icon={icon}
      >
        <span>Select Business Type</span>
      </Button>
      <Modal
        mask={mask}
        title={title}
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        closeIcon={<img className="closeIcon" src={closeIcon} />}
        okText="Apply"
        className="modal-container"
        style={style}
      >
        <Space direction="vertical" size="middle" style={{ display: "flex" }}>
          {() => console.log("Filter", interest)}

          <Form form={form}>
            <Form.List name="sectorsOutputs">
              {(fields, i) => (
                <>
                  <div className="filter-form-item">
                    <Form.Item>
                      <div className="label-with-logo">
                        <label className="label-text">Categories</label>
                        <img
                          src={poweredByLogo}
                          alt="Powered by Datacity"
                          className="powered-by-logo"
                        />
                      </div>
                      <Select
                        value={sectorValue}
                        onChange={(e) => sectorChange(e, i)}
                      >
                        {sectors?.map((Sector, i) => (
                          <Select.Option key={i} value={Sector.id}>
                            {Sector.name}
                          </Select.Option>
                        ))}
                      </Select>
                      {(sectorValue) ? (
                        <div className="filter-remove-btn">
                          <MinusCircleOutlined
                            onClick={() => deleteSelectedValue("sector")}
                          />
                        </div>
                      ) : ""}
                    </Form.Item>
                  </div>
                  <div className="filter-form-item">
                    <Form.Item name={["subSectorOutput", "name"]}>
                      <div className="label-with-logo">
                        <label className="label-text">Sub Categories</label>
                        <img
                          src={poweredByLogo}
                          alt="Powered by Datacity"
                          className="powered-by-logo"
                        />
                      </div>
                      <Select
                        value={subSectorValue}
                        onChange={(e) => subSectorChange(e, i)}
                      >
                        {subSectors &&
                          subSectors?.map((subSector, i) => (
                            <Select.Option key={i} value={subSector.id}>
                              {subSector.name}
                            </Select.Option>
                          ))}
                      </Select>
                      {(subSectorValue) ? (
                        <div className="filter-remove-btn">
                          <MinusCircleOutlined
                            onClick={() => deleteSelectedValue("subsector")}
                          />
                        </div>
                      ) : ""}
                    </Form.Item>
                  </div>
                  <div className="filter-form-item">
                    <Form.Item name="size">
                      <label className="label-text">Size</label>
                      <Select
                        value={sizeValue}
                        onChange={(e) => SizeChange(e, i)}
                      >
                        {OrganiationSizes.map((OrganiationSize, i) => (
                          <Select.Option key={i} value={OrganiationSize.id}>
                            {OrganiationSize.name}
                          </Select.Option>
                        ))}
                      </Select>
                      {(sizeValue) ? (
                        <div className="filter-remove-btn">
                          <MinusCircleOutlined
                            onClick={() => deleteSelectedValue("size")}
                          />
                        </div>
                      ) : ""}
                    </Form.Item>
                  </div>
                </>
              )}
            </Form.List>
          </Form>
        </Space>
      </Modal>
    </Fragment>
  );
}

export default FilterHub;
